module.exports = __webpack_public_path__ + "static/result_hongdae-514efd05be3375582a876b976b2c6c85.png";